import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Form, InputPassword, Title, Button, Text } from 'ui';
import { resetPassword } from 'api';
import queryString from 'query-string';
import logo from '../assets/logo-white.png'

export default function ResetPassword(props) {

  const history = useHistory();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState({});
  const [error, setError] = useState("");


  async function submit() {
    if(loading) {
      return;
    }
    setError("");
    if(!value.password) {
      setError("Please enter a new password.");
      return;
    }
    if(value.password !== value.confirmPassword) {
      setError("Your passwords don't match.");
      return;
    }
    try {
      setLoading(true);
      const params = queryString.parse(location.search);
      await resetPassword(value.password, params);
    }
    catch(error) {
      console.log(error);
      setLoading(false);
      setError(error.message || "Something went wrong. Please try again.");
      return;
    }

    setLoading(false);
    history.push("/");
  }

  return (
    <div className="auth auth-login">
      <Form onSubmit={submit} value={value} onChange={setValue} className="auth-sidebar">
        <div className="auth-logo">
          <img src={logo} alt="Taptivate"/>
        </div>
        <Title white className="auth-title">Choose new password.</Title>
        <InputPassword name="password" label="Password" white className="auth-input"/>
        <InputPassword name="confirmPassword" label="Confirm Password" white className="auth-input"/>
        <Button block small tertiary white className="auth-link" label="Login here." to="login"/>
        <Text block color="red" bold small>{error}</Text>
        <Button className="auth-button" white label={loading ? "Sending..." : "Send"} onClick={submit}/>
      </Form>
    </div>
  );
}